<template>
  <v-container class="mt-4  pr-4">
    <v-row>
      <v-col cols="12">
        <v-card class="transparent elevation-0">
          <v-card-title primary-title class="pb-0">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
          </v-card-title>
            
          <v-card-title primary-title>
            <v-spacer></v-spacer>
            <div class="text-center">
              <span class="text-subtitle-1">Clases disponibles</span>
              <br/>
              <span class="text-h4">{{ libres }}</span>
            </div>
            <v-spacer></v-spacer>

          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="6" lg="3" xl="2" v-for="(pago, i ) in paquetes" :key="i">
                <v-card class="shadowCard">
                  <v-card-title>
                    Folio: {{ pago.verbo + pago.idpagos }}
                  </v-card-title>
                  <v-card-text class="px-0">

                    <v-list class="transparent" dense> 
                      <v-list-item>
                        <v-list-item-title>Estatus</v-list-item-title>
                        <v-list-item-subtitle class="text-right">
                          <v-icon :color="pago.estatus == 'completed' ? 'green' : 'red'">mdi-circle-medium</v-icon>
                          {{ pago.estatus ? pago.estatus : 'Sin estatus' }}
                        </v-list-item-subtitle>
                      </v-list-item>

                      <v-list-item>
                        <v-list-item-title>Fecha de pago</v-list-item-title>
                        <v-list-item-subtitle class="text-right">
                          {{ pago.fecha_pago }}
                        </v-list-item-subtitle>
                      </v-list-item>

                      <v-list-item>
                        <v-list-item-title>Cantidad Clases</v-list-item-title>
                        <v-list-item-subtitle class="text-right">
                          {{ pago.cant_clases }}
                        </v-list-item-subtitle>
                      </v-list-item>

                      <v-list-item>
                        <v-list-item-title>Restan</v-list-item-title>
                        <v-list-item-subtitle class="text-right">
                          {{ pago.cant_clases_restantes }}
                        </v-list-item-subtitle>
                      </v-list-item>

                      <v-list-item>
                        <v-list-item-title>Pago</v-list-item-title>
                        <v-list-item-subtitle class="text-right">
                          {{ formatoMoneda( pago.costo ) }}
                        </v-list-item-subtitle>
                      </v-list-item>

                      <v-list-item>
                        <v-list-item-title>Limite</v-list-item-title>
                        <v-list-item-subtitle class="text-right">
                          {{ pago.limite }}
                        </v-list-item-subtitle>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn 
                      v-if="pago.estatus != 'completed'"
                      color="orange"
                      tile
                      block
                      dark
                      outlined
                      @click="openView(pago)"
                    >
                      Reintentar pago
                      <v-icon right>mdi-cash-check</v-icon>
                    </v-btn>

                    <v-btn 
                      v-else-if="pago.cant_clases_restantes > 0"
                      color="blue"
                      tile
                      block
                      dark
                      outlined
                      @click="editItem(pago)"
                    >
                      Reservar clases
                      <v-icon right>mdi-calendar</v-icon>
                    </v-btn>

                    <v-btn 
                      v-else
                      color="green"
                      tile
                      block
                      dark
                      outlined
                    >
                      COMPLETADO
                      <v-icon right>mdi-calendar</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialogo de editar o agregar-->
    <v-dialog
      v-model="dialog"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
        </v-card-title>

        <v-card-text class="text-h5 text-center">
          ¿Estás seguro de realizar está reservación?
        </v-card-text>

        <v-card-actions>
          <v-btn color="black" dark small tile @click="dialog = false">
            Cancelar
            <v-icon small right>mdi-cancel</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="red" dark small tile @click="saveReservacion()">
            Sí
            <v-icon small right>mdi-check</v-icon>
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <!-- Dialog de reservacion -->
    <v-dialog
      v-model="dialogReservacion"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
            <strong>Reservación de clases</strong>
          </span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-title>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
            <v-icon left @click="intervaloSemana -= 7, getProgramacionDia ( 0 + intervaloSemana, 'L' )">mdi-arrow-left-bold-circle</v-icon>
            <strong>{{ semana_formateada }}</strong>
            <v-icon right @click="intervaloSemana += 7, getProgramacionDia ( 0 + intervaloSemana, 'L' )">mdi-arrow-right-bold-circle</v-icon>
          </span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-row>

            <v-col cols="12">
                <v-row>
                  <v-col cols="2">
                    <v-card
                      class="pa-2 text-center"
                      @click="numero_dia > 1 ? '' : getProgramacionDia( 0 + intervaloSemana, 'L' )"
                      :color="letra_dia == 'L' ? 'primary' : 'white'"
                      :dark="letra_dia == 'L' ? true : false"
                    >
                      L
                    </v-card>
                  </v-col>

                  <v-col cols="2">
                    <v-card
                      class="pa-2 text-center"
                      @click="numero_dia > 2 ? '' : getProgramacionDia( 1 + intervaloSemana, 'M' )"
                      :color="letra_dia == 'M' ? 'primary' : 'white'"
                      :dark="letra_dia == 'M' ? true : false"
                    >
                      M
                    </v-card>
                  </v-col>

                  <v-col cols="2">
                    <v-card
                      class="pa-2 text-center"
                      @click="numero_dia > 3 ? '' : getProgramacionDia( 2 + intervaloSemana, 'X' )"
                      :color="letra_dia == 'X' ? 'primary' : 'white'"
                      :dark="letra_dia == 'X' ? true : false"
                    >
                      X
                    </v-card>
                  </v-col>

                  <v-col cols="2">
                    <v-card
                      class="pa-2 text-center"
                      @click="numero_dia > 4 ? '' : getProgramacionDia( 3 + intervaloSemana, 'J' )"
                      :color="letra_dia == 'J' ? 'primary' : 'white'"
                      :dark="letra_dia == 'J' ? true : false"
                    >
                      J
                    </v-card>
                  </v-col>

                  <v-col cols="2">
                    <v-card
                      class="pa-2 text-center"
                      @click="numero_dia > 5 ? '' : getProgramacionDia( 4 + intervaloSemana, 'V' )"
                      :color="letra_dia == 'V' ? 'primary' : 'white'"
                      :dark="letra_dia == 'V' ? true : false"
                    >
                      V
                    </v-card>
                  </v-col>

                  <v-col cols="2">
                    <v-card
                      class="pa-2 text-center"
                      @click="numero_dia >= 6 ? '' : getProgramacionDia( 5 + intervaloSemana, 'S' )"
                      :color="letra_dia == 'S' ? 'primary' : 'white'"
                      :dark="letra_dia == 'S' ? true : false"
                    >
                      S
                    </v-card>
                  </v-col>
                  
                </v-row>
              </v-col>

              <br/>

              <v-card
                class="shadowCard pa-4" 
                v-if="idcategorias"
              >
                {{ idcategorias.detalles }}
              </v-card>
            </v-col>

            <v-card-title>
              <v-spacer></v-spacer>
              <span class="text-subtitle-1">
                <strong>Clases restantes: {{ restan }}</strong>
              </span>
              <v-spacer></v-spacer>
            </v-card-title>

            
            <v-alert
              dense
              outlined
              type="warning"
              v-if="!progra.length"
            >
              No existen clases programadas para este día!
            </v-alert>

            <v-col cols="12" v-for="(clase, i ) in filterProga" :key="i">
              <v-card class="shadowCard">
                <v-card-text class="pa-0">
                  <v-list-item three-line>
                    <v-list-item-content class="pb-0">
                      <div class="text-overline mb-4">
                        <v-chip :color="clase.color" small dark> {{ clase.categoria }} </v-chip>
                      </div>
                      <div> <b>Día:</b> {{ clase.dia }}</div>
                      <br/>
                      <div>  <b>Hora:</b> {{ clase.hora_inicio.substr(0,5) + ' a ' + clase.hora_fin.substr(0,5) }}</div>
                      <br/>
                      <div> <b>Quedan:</b> {{ clase.restan }} lugares</div>
                    </v-list-item-content>

                    <v-list-item-avatar
                      tile
                      size="80"
                      color="transparent"
                    >
                      <v-avatar
                        size="80"
                        color="grey"
                      >
                        <img :src="url + clase.foto" />
                      </v-avatar>
                    </v-list-item-avatar>
                  </v-list-item>

                </v-card-text>
                <v-card-actions class="pt-0">
                  <v-spacer></v-spacer>
                  <!-- <v-btn
                    tile
                    color="red"
                    small
                    dark
                    block
                    outlined
                    @click="previaReserva( clase )"
                    v-if="!clase.idreservaciones"
                  >
                    Reservar
                    <v-icon small right> mdi-calendar </v-icon>
                  </v-btn> -->

                  <v-checkbox
                    label="Reservar está clase"
                    v-model="clase.reservar"
                    small
                    @change="contador( clase )"
                    hide-details
                    v-if="!clase.idreservaciones"
                  >
                  </v-checkbox>

                  <v-btn
                    tile
                    color="green"
                    small
                    dark
                    block
                    outlined
                    v-else-if="clase.idreservaciones"
                  >
                    Reservada
                    <v-icon small right> mdi-calendar </v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-btn 
            color="transparent elevation-0"
            x-small
            absolute
            top
            right
            fab
            class="mt-5 mr-0"
            @click="dialogReservacion = false"
           ><v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-text>



        <v-card-actions v-if="clasesSeleccionadas.length">
          <v-btn
            color="red"
            dark
            tile
            block
            @click="dialog = true"
          >
            Reservar mis clases : {{ clasesSeleccionadas.length }}
          </v-btn>
        </v-card-actions>


      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'


  export default {

    mixins: [ validarErrores, funcionesExcel ],

    components:{
      Alerta,
      carga,
    },

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idpaquetes:0,
        paquete:'',
        cant_clases:0,
        costo:0,
        limite_dias:0,
        deleted:0,
        fecha_creacion:null,
      },

      defaultItem: {
        idpaquetes:0,
        paquete:'',
        cant_clases:0,
        costo:0,
        limite_dias:0,
        deleted:0,
        fecha_creacion:null,
      },

      dialogReservacion: false,

      contadorClases: 0,

      clasesSeleccionadas:[],
      page:0,

      // tabla
      paquetes: [],

      libres: 0,
      progra:[],

      url: false,

      clase: null,

      categorias: [],

      idcategorias:null,
      dia: 'L',

      fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      intervalo:0,

      semana_formateada: '',
      numero_dia: 0,
      letra_dia:'',

      intervaloSemana: 0
    }),

    computed: {
      ...mapGetters('login',['getdatosUsuarioFitHouse']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar categoria' : 'Editar categoria'
      },

      restan( ){

        return this.editedItem.cant_clases_restantes - this.contadorClases

      },

      filterProga( ){


        if( this.restan == 0 ){
          return this.clasesSeleccionadas
        }else{
          return this.progra
        }

      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

      fecha(){ this.getProgramacionDia( 0, 'L' ) },


      idcategorias( val ){
        if( val ){ return this.getPromgramacionCategoria( ) }
      }

    },

    async created () {
      this.url = this.$http.options.root + 'fotos-fithouse/'
      await this.initialize()
      await this.getCantidadClases()
      await this.getCategorias( )
    },

    methods: {
      initialize () {
        this.getCantidadClases()
        this.cargar = true
        this.paquetes = []
        return this.$http.get('mis.historial.pagos/' + this.getdatosUsuarioFitHouse.idusuarios).then(response=>{
          this.paquetes = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getCategorias () {
        this.cargar = true
        this.categorias = []
        return this.$http.get('categorias.list').then(response=>{
          this.categorias = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getCantidadClases () {
        this.cargar = true
        this.libres = 0
        return this.$http.get('mis.cantidad.clases/' + this.getdatosUsuarioFitHouse.idusuarios ).then(response=>{
          this.libres = response.body.cantidadClases
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getPromgramacionCategoria( ){
        this.cargar = true
        this.progra = []  

        let payload = {
          idusuarios    : this.getdatosUsuarioFitHouse.idusuarios,
          idcategorias  : this.idcategorias.idcategorias,
        }     

        return this.$http.post('programacion.categoria', payload ).then(response=>{
          this.progra = response.data
          this.dialogReservacion = true
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.paquetes.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.getProgramacionDia( 0, 'L' )
      },

      getProgramacionDia( intervalo, letra ){
        this.cargar = true
        this.progra = []  

        let payload = {
          dia           : this.fecha,
          intervalo     : intervalo,
          idusuarios    : this.getdatosUsuarioFitHouse.idusuarios,
        }     

        return this.$http.post('programacion.dia', payload ).then(response=>{
          this.progra            = response.data.progra
          this.semana_formateada = response.data.semana_formateada
          this.numero_dia        = response.data.numero_dia

          this.letra_dia         = letra
          
          this.dialogReservacion = true
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      formatoMoneda(monto) {
        const formato = new Intl.NumberFormat('es-MX', {
          style: 'currency',
          currency: 'MXN',
        });

        return formato.format(monto);
      },

      openView( pago ){
        window.open( pago.url_pago )
      },

      previaReserva ( clase ) {
        if( this.editedItem.cant_clases_restantes > 0  ){
          this.clase = clase
          this.dialog = true
        }else{
          this.validarErrorDirecto('Tu paquete ya no cuenta con clases disponibles, por favor, selecciona otro paquete o realiza la compra de alguno.')
        }
      },

      previousDay () {
        const siguienteDia = new Date(this.fecha);
        siguienteDia.setDate(siguienteDia.getDate() - 1);
        this.fecha = siguienteDia.toISOString().substr(0, 10);
      },
      
      nextDay () {
        const siguienteDia = new Date(this.fecha);
        siguienteDia.setDate(siguienteDia.getDate() + 1);
        this.fecha = siguienteDia.toISOString().substr(0, 10);
      },

      saveReservacion( ){
        const payload = {
          idpago        : this.editedItem.idpagos,
          idusuarios    : this.getdatosUsuarioFitHouse.idusuarios,
          clases        : this.clasesSeleccionadas
        }

        this.cargar = true
        // Lo mandapos por el EP
        this.$http.post('programacion.reservacion', payload).then(response=>{
          // this.editedItem.cant_clases_restantes - 1
          this.contadorClases      = 0
          this.clasesSeleccionadas = []
          this.dialogReservacion   = false
          this.dialog              = false
          this.cargar              = false
          this.validarSuccess('Para ver tu reservación, ve a tu calendario!')
          this.initialize()
          this.getProgramacionDia()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      reservarMisClases( ){

      },

      contador( value ){

        this.contadorClases = value.reservar ? this.contadorClases + 1 : this.contadorClases - 1

        if( value.reservar ){
          this.clasesSeleccionadas.push( value )
        }else{
          this.clasesSeleccionadas = this.clasesSeleccionadas.filter( el => el.idprogramacion != value.idprogramacion )
        }


      }
    },
  }
</script>


